module.exports = __webpack_public_path__ + "public/img/unfinishTask.65be7a5e.png";